import { translate } from '@vimeo/i18n-runtime';

export const SHOWCASE_ERROR_MESSAGE = {
  PRIVACY_ERROR: {
    heading: translate('This is private'),
    body: translate('Sorry, you don’t have permission to watch here.'),
  },
};

export const ErrorTypes = {
  PRIVACY_ERROR: 'PRIVACY_ERROR',
} as const;

export type ErrorType = (typeof ErrorTypes)[keyof typeof ErrorTypes];
